import React from 'react';
import PropTypes from "prop-types";
import Select from "react-select";
import cx from "classnames";

const SimpleValue = ({options, value, optionValue, children, ...rest}) => {

    value = value !== null && value !== undefined && value !== ""
        ? options.find(option => option[optionValue] === value)
        : value;
    return children({options, value, ...rest});
};

const SelectD1 = (props) => {

    const {
        isClearable,
        isDisabled,
        disableOptions,
        className,
        label,
        isMulti,
        placeholder,
        options,
        optionLabel,
        optionValue = "id",
        size,
        isSearchable,
        menuPlacement,
        value,
        styles,
        onChangeHandle = () => {
        }
    } = props;

    const classes = cx(
        'form-field',
        value && 'form-field--active',
        className
    );

    const getSizeHeight = () => {
        switch (size) {
            case 'default':
                return '48px';
            case 'small':
                return '38px';
            case 'large':
                return '58';
            default:
                return '48px'
        }
    }
    const getSizeRadius = () => {
        switch (size) {
            case 'default':
                return '10px';
            case 'small':
                return '5px';
            case 'large':
                return '15px';
            default:
                return '10px'
        }
    }
    const getSizeFont = () => {
        switch (size) {
            case 'default':
                return '16px';
            case 'small':
                return '14px';
            case 'large':
                return '18px';
            default:
                return '16px'
        }
    }

    const customStyle = {
        control: (provided) => ({
            ...provided,
            cursor: "pointer",
            borderColor: "rgba(0,0,0,.1)",
            border: "1px solid #e1e2e6",
            minHeight: getSizeHeight(),
            borderRadius: getSizeRadius(),
        }),
        container: (provided) => ({
            ...provided,
            minHeight: getSizeHeight(),
            minWidth: "150px"
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            display: "none"
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: getSizeHeight(),
        }),
        option: (provided) => ({
            ...provided,
            fontSize: getSizeFont(),
            fontFamily: "Inter",
        }),
        placeholder: (provided) => ({
            ...provided,
            fontSize: getSizeFont(),
            fontFamily: "Inter",
            whiteSpace: "nowrap",
            color: "#bfbfbf",
            overflow: "hidden",
            textOverflow: "ellipsis"
        }),
        menuPortal: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
    };

    return (
        <div className={classes}>
            {label && (
                <div className="form-field__label">{label}</div>
            )}
            <SimpleValue
                onChange={option => {
                    onChangeHandle(option)
                }}
                options={options}
                optionValue={optionValue}
                getValue={option => option[optionValue]}
                getOptionLabel={option => option[optionLabel]}
                getOptionValue={option => option[optionValue]}
                placeholder={placeholder}
                styles={styles || customStyle}
                value={value}
                isDisabled={isDisabled}
                isMulti={isMulti}
                isSearchable={isSearchable}
                isClearable={isClearable}
                menuPlacement={menuPlacement}
                menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                isOptionDisabled={(option) => disableOptions.reduce((prev, curr) => [...prev, curr.id], []).includes(option.id)}
            >
                {simpleProps => (
                    <Select {...simpleProps}/>
                )}
            </SimpleValue>
        </div>
    );
};

SelectD1.propTypes = {
    label: PropTypes.string.isRequired,
    optionLabel: PropTypes.string,
    optionValue: PropTypes.string,
    options: PropTypes.array.isRequired,
    isSearchable: PropTypes.bool,
    isClearable: PropTypes.bool,
    menuPlacement: PropTypes.string,
    className: PropTypes.string,
    size: PropTypes.string,
};

SelectD1.defaultProps = {
    optionLabel: "name",
    optionValue: "value",
    value: '',
    isSearchable: false,
    isClearable: false,
    menuPlacement: "bottom",
    className: "",
    label: "",
    disableOptions: [],
    size: "default",
};

export default SelectD1;
